<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">Supported Categories</h1>

        <section class="content-section">
            <p class="desc-text">XigCheck currently supports authentication review services for selected high-value and collectible product categories.</p>
            <p class="desc-text">Covered categories may include:</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">Luxury Handbags</h2>
            <ul class="policy-list">
                <li>designer handbags</li>
                <li>leather handbags</li>
                <li>limited edition handbags</li>
                <li>collectible handbags</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">Luxury Accessories</h2>
            <ul class="policy-list">
                <li>wallets</li>
                <li>belts</li>
                <li>scarves</li>
                <li>fashion accessories</li>
                <li>small leather goods</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">Luxury Footwear &amp; Sneakers</h2>
            <ul class="policy-list">
                <li>premium sneakers</li>
                <li>collectible sneakers</li>
                <li>designer footwear</li>
                <li>limited-release footwear</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">Luxury Fashion &amp; Apparel</h2>
            <ul class="policy-list">
                <li>luxury clothing</li>
                <li>collectible streetwear</li>
                <li>designer outerwear</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">Luxury Eyewear</h2>
            <ul class="policy-list">
                <li>sunglasses</li>
                <li>designer eyewear</li>
                <li>collectible eyewear</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">Selected Home &amp; Lifestyle Goods</h2>
            <ul class="policy-list">
                <li>selected home accessories</li>
                <li>selected decorative goods</li>
            </ul>
        </section>

        <section class="content-section">
            <p class="desc-text">Additional categories may be introduced periodically based on authentication partner coverage and marketplace compliance standards.</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'XigcheckSupportedCategories'
}
</script>

<style scoped>
@import './xigcheck-doc.css';
</style>
